import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/data',
      name: 'data',
      component: () => import('./views/Data.vue')
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('./views/Notify.vue')
    },
    {
      path: '/firings',
      name: 'firings',
      component: () => import('./views/Firings.vue')
    },
    {
      path: '/realtime',
      name: 'realtime',
      component: () => import('./views/Realtime.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('./views/Logout.vue')
    }
  ]
})
